import {Fields} from '../types'

const buildRangeErrorCodes = (field: Fields) => ({
  required: `${field}-required`,
  notAllowed: `${field}-not-allowed`,
  outOfRange: `${field}-out-of-range`,
  invalidStep: `${field}-invalid-step`
})

export const ErrorCodes = {
  timeOnJobSite: buildRangeErrorCodes('timeOnJobSite'),
  flowRate: buildRangeErrorCodes('flowRate'),
  spacing: buildRangeErrorCodes('loadSpace')
} as const
